import React, { useEffect, useState } from "react";
import { styles } from "../../stylesheets/simulateurs.css";
import "../../stylesheets/simulateursBis.css";
import ButtonYesno from "../buttons/button.yesno.js";
import { ToolTipPerso } from "../selects/tooltip_perso";
import TextfieldNumber from "../textfields/textfield.number";
import TextfieldAbattement from "../textfields/textfield.abattement";

const Souche_Representant = (props) => {
  const [handicap, setHandicap] = useState(0);
  const [beneficiaireAssuranceVie, setBeneficiaireAssuranceVie] = useState(0);
  const [montantTaxableArticle757b, setMontantTaxableArticle757b] = useState(0);
  const [partAbattementLegalRestant, setPartAbattementLegalRestant] = useState(0);

  const formatNumber = (n) => new Intl.NumberFormat("fr-FR").format(Number(n || 0));
  const toInt = (value) => Number(value) || 0;

  useEffect(() => {
    setInRedux(null, null);
  }, [props.simulateurid]);

  const handleChange = async (setter, value) => {
    if (setter === setBeneficiaireAssuranceVie && toInt(value) !== 1) {
      setMontantTaxableArticle757b(0);
      setPartAbattementLegalRestant(0);
    }
    setter(value);
    setInRedux(setter, value);
  };

  function setInRedux(setter, value) {
    const beneficiaireAssuranceVieValue =
      setter === setBeneficiaireAssuranceVie ? toInt(value) : toInt(beneficiaireAssuranceVie);

    let object = {
      handicap: toInt(handicap),
      beneficiaire_assurance_vie: beneficiaireAssuranceVieValue,
      representant_index: props.soloResultKey + 1,
    };

    if (beneficiaireAssuranceVieValue === 1) {
      object.montant_taxable_article757b =
        setter === setMontantTaxableArticle757b ? toInt(value) : toInt(montantTaxableArticle757b);
      object.part_abattement_legal_restant =
        setter === setPartAbattementLegalRestant ? toInt(value) : toInt(partAbattementLegalRestant);
    }

    if (setter === setHandicap) { Object.assign(object, { handicap: toInt(value) }); }
    if (setter === setBeneficiaireAssuranceVie) {
      Object.assign(object, {
        beneficiaire_assurance_vie: toInt(value),
      });
    }
    if (setter === setMontantTaxableArticle757b && beneficiaireAssuranceVieValue === 1) {
      Object.assign(object, { montant_taxable_article757b: toInt(value) });
    }
    if (setter === setPartAbattementLegalRestant && beneficiaireAssuranceVieValue === 1) {
      Object.assign(object, { part_abattement_legal_restant: toInt(value) });
    }

    props.functionSetSoloResults(props.soloResultKey, object);
  }

  return (
    <div style={styles.cardFlexContainer}>

      <div style={styles.cardTitleDonataire}>Représentant {props.soloResultKey + 1}</div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          Le représentant est-il en situation de handicap ?
          <ToolTipPerso
            title={
              "Cas de l'héritier incapable de travailler dans des conditions normales de rentabilité, en raison d'une infirmité physique ou mentale, congénitale ou acquise (CGI, art. 779, BOI-ENR-DMTG-10-50-20, § 120 à 190)."
            }
          />
        </div>
        <ButtonYesno handleChange={handleChange} setter={setHandicap} defaultValue={0} />
      </div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>Montant correspondant au représentant {props.soloResultKey + 1}</div>
        <TextfieldAbattement type={"number"} placeholder={`${formatNumber(props.montantRepresentant)} €`} />
      </div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>Abattement légal correspondant au représentant {props.soloResultKey + 1}</div>
        <TextfieldAbattement type={"number"} placeholder={`${formatNumber(props.abattementLegalRepresentant)} €`} />
      </div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          Le représentant est également désigné bénéficiaire d’un ou plusieurs contrats d’assurance-vie ?
        </div>
        <ButtonYesno handleChange={handleChange} setter={setBeneficiaireAssuranceVie} defaultValue={0} />
      </div>

      {beneficiaireAssuranceVie === 1 ? (
        <>
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Montant taxable au titre de l'article 757 B du CGI
              <ToolTipPerso
                title={
                  "Quote-part des primes des versées sur le ou les contrats d'assurance-vie après le 70e anniversaire de l'assuré, après application du prorata d'abattement de 30 500 € applicable à l'héritier bénéficiaire."
                }
              />
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontantTaxableArticle757b}
            />
          </div>

          {parseInt(props.lienParenteSuccession || 0) === 2 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Part de l’abattement légal restante dans le rappel fiscal de 15 ans
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setPartAbattementLegalRestant}
            />
          </div>
          ) : null}
        </>
      ) : (
        <></>
      )}

    </div>
  );
};

export default Souche_Representant;
